




























import { Component, Vue, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import getActivityType from '@/common/utils/getActivityType';
import getUrlParam from "@/common/utils/getUrlParam";
@Component
export default class GuideMask extends Vue {
  @Prop() show!: boolean;

  @Getter("nickname") nickname!: string;
  @Getter("avatar") avatar!: string;
  @Getter("uid") uid!: string;
  @Getter("hasSignIn") hasSignIn!: boolean;
  @Getter("cancel") cancel!: boolean;
  @Getter("distributeTradeId") distributeTradeId!: string;
  @Getter("distributeTypeParameter") distributeTypeParameter!: any;
  @Getter("hasPay") hasPay!: number;

  broadcastId: string = (getUrlParam('broadcastId') as string);
  distribute: boolean = getActivityType() === 'distributeType';

  toMyReward(){
      if (window.__wxjs_environment === 'miniprogram'){
        const distributorId = getUrlParam("distributorId");
        let shareFlag = 'YES';
        // 未报名，已支付/未支付且取消报名
        if (this.distributeTypeParameter.distributeMode === 'AFTER_BUY' && (this.cancel || !this.uid || (this.uid && this.hasPay === 3))) {
          shareFlag = 'NO';
        }
        const url = `/pages/my-reward/index?activityId=${this.broadcastId}&nickname=${this.nickname}&shareFlag=${shareFlag}&avatar=${this.avatar}`+ (distributorId ? `&distributorId=${distributorId}` : `&distributorId=-1`) + (this.uid ? `&parentUid=${this.uid}` : `&parentUid=`);
        if(this.nickname) {
          window.wx.miniProgram.navigateTo({
            url: url
          });
        } else {
          Vue.$loading.show("正在加载..");
          setTimeout(() => {
            window.wx.miniProgram.navigateTo({
              url: url
            });
            Vue.$loading.hide();
          }, 3000);
        }
      }
  }
     toOrderDetail(){
      if (window.__wxjs_environment === 'miniprogram'){
        const broadcastId = getUrlParam("broadcastId");
        let shareFlag = 'YES';
        // 未报名，已支付/未支付且取消报名
        if (this.distributeTypeParameter.distributeMode === 'AFTER_BUY' && (this.cancel || !this.uid)) {
          shareFlag = 'NO';
        }
        const scene = `tradeId=${this.distributeTradeId}&shareFlag=${shareFlag}`;
        window.wx.miniProgram.navigateTo({
          url: `/pages/order-detail/index?${scene}`
        });
      }
    }
}
